import { EventTypeAction } from './utils';

// Mapping màu sắc cho các loại hoạt động
export const ACTIVITY_COLORS = {
  0: '#A8E6CF',   // Đăng nhập - Xanh mint nhạt
  1: '#DCEEFB',   // Đăng xuất - Xanh dương nhạt
  2: '#E8F4F8',   // Thay đổi mật khẩu - Xanh xám nhạt
  3: '#F0E68C',   // Thiết lập cấu hình hệ thống - Vàng nhạt
  4: '#DDA0DD',   // Thiết lập làn vào ra - Tím nhạt
  5: '#F5DEB3',   // Thiết lập thiết bị - Beige
  6: '#87CEEB',   // Sửa số xe - Xanh trời
  7: '#FF6B6B',   // Mở barrier bằng tay - Đỏ coral
  8: '#FF8E53',   // Đóng barrier bằng tay - Cam đỏ
  9: '#4ECDC4',   // Miễn phí gửi xe - Xanh turquoise
  10: '#90EE90',  // Xe vào ra hợp lệ - Xanh lá nhạt
  11: '#45B7D1',  // Thay đổi dữ liệu - Xanh dương
  12: '#FFA07A',  // Xóa dữ liệu - Cam nhạt
  '12_RECORD': '#FF6347',  // Xóa bản ghi - Đỏ cà chua
  '12_TICKET': '#FFB347',  // Xóa vé xe - Cam sáng
  13: '#98D8C8'   // Xả thẻ - Xanh mint
};

// Search terms cho từng loại hoạt động
export const ACTIVITY_SEARCH_TERMS = {
  0: ['Đăng nhập', 'đăng nhập', 'Login', 'login'],
  1: ['Đăng xuất', 'đăng xuất', 'Logout', 'logout'],
  2: ['Thay đổi mật khẩu', 'thay đổi mật khẩu', 'Change password', 'change password'],
  3: ['Thiết lập cấu hình', 'thiết lập cấu hình', 'System config', 'system config'],
  4: ['Thiết lập làn', 'thiết lập làn', 'Lane setup', 'lane setup'],
  5: ['Thiết lập thiết bị', 'thiết lập thiết bị', 'Device setup', 'device setup'],
  6: ['Sửa số xe', 'sửa số xe', 'Edit vehicle', 'edit vehicle'],
  7: ['Mở barrier', 'mở barrier', 'Manual open', 'Mở tùy ý'],
  8: ['Đóng barrier', 'đóng barrier', 'Manual close'],
  9: ['miễn phí', 'Miễn phí', 'free', 'Fee waived'],
  10: ['Xe vào ra hợp lệ', 'xe vào ra hợp lệ', 'Valid entry', 'valid entry'],
  11: ['cập nhật', 'sửa', 'Update', 'Edit', 'Thay đổi'],
  12: ['Xóa', 'xóa', 'delete', 'Delete'],
  '12_RECORD': ['Xoá bản ghi vào ra', 'xóa bản ghi vào ra', 'Xóa bản ghi', 'xóa bản ghi'],
  '12_TICKET': ['Xoá vé xe', 'xóa vé xe', 'Xóa vé xe', 'Loại vé'],
  13: ['xả thẻ', 'Xả thẻ', 'release card', 'Card release']
};

// Tạo danh sách hoạt động cần thống kê
export const createTargetActivities = (includeIds = [ 7, 8, 9, 11, '12_RECORD', '12_TICKET', 13]) => {
  return includeIds.map(id => {
    // Xử lý các loại con của type 12
    if (id === '12_RECORD') {
      return {
        id: '12_RECORD',
        parentId: 12,
        key: 'ACTIVITY_12_RECORD',
        name: 'Xóa bản ghi vào ra',
        color: ACTIVITY_COLORS['12_RECORD'] || '#FF6347',
        searchTerms: ACTIVITY_SEARCH_TERMS['12_RECORD'] || []
      };
    }
    
    if (id === '12_TICKET') {
      return {
        id: '12_TICKET',
        parentId: 12,
        key: 'ACTIVITY_12_TICKET',
        name: 'Xóa vé xe',
        color: ACTIVITY_COLORS['12_TICKET'] || '#FFB347',
        searchTerms: ACTIVITY_SEARCH_TERMS['12_TICKET'] || []
      };
    }
    
    // Xử lý các type thông thường
    const eventType = EventTypeAction.find(event => event.id === id);
    if (!eventType) return null;

    return {
      id: id,
      key: `ACTIVITY_${id}`,
      name: eventType.value,
      color: ACTIVITY_COLORS[id] || '#95A5A6',
      searchTerms: ACTIVITY_SEARCH_TERMS[id] || []
    };
  }).filter(Boolean);
};

// Phân loại hoạt động dựa trên type và nội dung
export const classifyActivity = (record, targetActivities) => {
  // Kiểm tra input hợp lệ
  if (!record || typeof record !== 'object') {
    console.warn('⚠️ Invalid record:', record);
    return null;
  }
  
  const { type, note, detail } = record;
  
  // Xử lý đặc biệt cho type 12 - phân chia thành 2 loại
  if (type === 12) {
    const safeNote = (note && typeof note === 'string') ? note : '';
    const safeDetail = (detail && typeof detail === 'string') ? detail : '';
    
    // Phân loại dựa trên nội dung note
    if (safeNote.includes('Xoá bản ghi vào ra') || safeNote.includes('xóa bản ghi vào ra')) {
      const recordActivity = targetActivities.find(activity => activity.id === '12_RECORD');
      return recordActivity ? recordActivity.key : null;
    }
    
    if (safeNote.includes('Xoá vé xe') || safeNote.includes('xóa vé xe') || safeNote.includes('Loại vé')) {
      const ticketActivity = targetActivities.find(activity => activity.id === '12_TICKET');
      return ticketActivity ? ticketActivity.key : null;
    }
    
    // Mặc định cho type 12 nếu không phân loại được
    const defaultActivity = targetActivities.find(activity => activity.id === 12);
    return defaultActivity ? defaultActivity.key : null;
  }
  
  // Tìm activity dựa trên type trước (cho các type khác)
  if (type !== undefined && type !== null) {
    const activityById = targetActivities.find(activity => activity.id === type);
    if (activityById) {
      return activityById.key;
    }
  }
  
  // Nếu không tìm thấy theo ID, tìm theo searchTerms
  // Đảm bảo note và detail không null trước khi gọi includes
  const safeNote = (note && typeof note === 'string') ? note : '';
  const safeDetail = (detail && typeof detail === 'string') ? detail : '';
  
  if (safeNote || safeDetail) {
    for (const activity of targetActivities) {
      if (!activity.searchTerms || !Array.isArray(activity.searchTerms)) {
        continue;
      }
      
      const found = activity.searchTerms.some(term => {
        if (typeof term !== 'string') return false;
        return safeNote.includes(term) || safeDetail.includes(term);
      });
      
      if (found) {
        return activity.key;
      }
    }
  }
  
  return null;
};

// Format số liệu cho tooltip
export const formatTooltip = function() {
  let tooltip = `<b>${this.x}</b><br/>`;
  this.points.forEach(point => {
    tooltip += `<span style="color:${point.color}">${point.series.name}</span>: <b>${point.y}</b> lượt<br/>`;
  });
  return tooltip;
};

// Debug function để theo dõi các activity không được phân loại
export const debugUnclassifiedActivities = (data, targetActivities) => {
  const unclassified = [];
  const typeStats = {};
  const type12Details = { record: 0, ticket: 0, unclassified: 0 }; // Thống kê riêng cho type 12
  
  if (!Array.isArray(data)) {
    console.warn('⚠️ Data is not an array:', data);
    return { typeStats: {}, unclassified: [] };
  }
  
  data.forEach((record, index) => {
    try {
      const { type, note, detail } = record || {};
      
      // Đảm bảo note và detail không null
      const safeNote = (note && typeof note === 'string') ? note : '';
      const safeDetail = (detail && typeof detail === 'string') ? detail : '';
      
      // Thống kê đặc biệt cho type 12
      if (type === 12) {
        if (safeNote.includes('Xoá bản ghi vào ra') || safeNote.includes('xóa bản ghi vào ra')) {
          type12Details.record++;
        } else if (safeNote.includes('Xoá vé xe') || safeNote.includes('xóa vé xe') || safeNote.includes('Loại vé')) {
          type12Details.ticket++;
        } else {
          type12Details.unclassified++;
        }
      }
      
      // Thống kê các type xuất hiện
      if (type !== undefined && type !== null) {
        if (!typeStats[type]) {
          typeStats[type] = { count: 0, samples: [] };
        }
        typeStats[type].count++;
        if (typeStats[type].samples.length < 3) {
          typeStats[type].samples.push({ note: safeNote, detail: safeDetail });
        }
      }
      
      // Tìm các record không được phân loại
      const activityType = classifyActivity(record, targetActivities);
      if (!activityType) {
        unclassified.push({ 
          index,
          type, 
          note: safeNote.substring(0, 100), 
          detail: safeDetail.substring(0, 50)
        });
      }
    } catch (error) {
      console.error(`⚠️ Error processing record at index ${index}:`, error, record);
    }
  });
  
  console.log('📊 Type Statistics:', typeStats);
  console.log('🔍 Type 12 Breakdown:', type12Details);
  console.log('⚠️ Unclassified Activities:', unclassified.slice(0, 10));
  
  return { typeStats, unclassified, type12Details };
}; 